import { cmsApi } from '../constants/constants';
import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var GoodgovernenceService = /** @class */ (function () {
    function GoodgovernenceService(http) {
        this.http = http;
        this.checkMonth = [
            {
                number: 1,
                name: 'มกราคม'
            },
            {
                number: 2,
                name: 'กุมภาพันธ์'
            },
            {
                number: 3,
                name: 'มีนาคม'
            },
            {
                number: 4,
                name: 'เมษายน'
            },
            {
                number: 5,
                name: 'พฤษภาคม'
            },
            {
                number: 6,
                name: 'มิถุนายน'
            },
            {
                number: 7,
                name: 'กรกฎาคม'
            },
            {
                number: 8,
                name: 'สิงหาคม'
            },
            {
                number: 9,
                name: 'กันยายน'
            },
            {
                number: 10,
                name: 'ตุลาคม'
            },
            {
                number: 11,
                name: 'พฤศจิกายน'
            },
            {
                number: 12,
                name: 'ธันวาคม'
            }
        ];
    }
    GoodgovernenceService.prototype.get_GoodgovernenceList = function () {
        var _getNewsPeriodUrl = cmsApi + '/get_GoodgovernenceList/';
        var _getNewsPeriodBody = {};
        return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody);
    };
    GoodgovernenceService.prototype.get_governenceById = function (governence_id) {
        var _getNewsPeriodUrl = cmsApi + '/get_governenceById/';
        var _getNewsPeriodBody = { governence_id: governence_id };
        return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody);
    };
    GoodgovernenceService.prototype.get_ethicById = function (ethic_id) {
        var _getNewsPeriodUrl = cmsApi + '/get_ethicById/';
        var _getNewsPeriodBody = { ethic_id: ethic_id };
        return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody);
    };
    GoodgovernenceService.prototype.get_corruptionById = function (corruptionid) {
        var _getNewsPeriodUrl = cmsApi + '/get_corruptionById/';
        var _getNewsPeriodBody = { corruption_id: corruptionid };
        return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody);
    };
    GoodgovernenceService.prototype.get_productById = function (product_id) {
        var _getNewsPeriodUrl = cmsApi + '/get_productById/';
        var _getNewsPeriodBody = { product_id: product_id };
        return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody);
    };
    GoodgovernenceService.prototype.get_ethicList = function () {
        var _getNewsPeriodUrl = cmsApi + '/get_ethicList/';
        var _getNewsPeriodBody = { IsActive: "1",
            search: "" };
        return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody);
    };
    GoodgovernenceService.prototype.get_corruptionList = function () {
        var _getNewsPeriodUrl = cmsApi + '/get_corruptionList/';
        var _getNewsPeriodBody = { IsActive: "1",
            search: "" };
        return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody);
    };
    GoodgovernenceService.prototype.get_productList = function () {
        var _getNewsPeriodUrl = cmsApi + '/get_productList/';
        var _getNewsPeriodBody = { IsActive: "1",
            search: "" };
        return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody);
    };
    GoodgovernenceService.prototype.changeFormatDate_dd = function (date) {
        if (date === '') {
            return null;
        }
        else {
            var d = new Date(date);
            var month_1 = d.getMonth() + 1;
            var day = d.getDate();
            var year = d.getFullYear() + 543;
            var monthTh = this.checkMonth.filter(function (m) { return m['number'] === month_1; })[0];
            return day;
        }
    };
    GoodgovernenceService.prototype.changeFormatDate_MM = function (date) {
        if (date === '') {
            return null;
        }
        else {
            var d = new Date(date);
            var month_2 = d.getMonth() + 1;
            var day = d.getDate();
            var year = d.getFullYear() + 543;
            var monthTh = this.checkMonth.filter(function (m) { return m['number'] === month_2; })[0];
            return monthTh['name'];
        }
    };
    GoodgovernenceService.prototype.changeFormatDate_yy = function (date) {
        if (date === '') {
            return null;
        }
        else {
            var d = new Date(date);
            var month_3 = d.getMonth() + 1;
            var day = d.getDate();
            var year = d.getFullYear() + 543;
            var monthTh = this.checkMonth.filter(function (m) { return m['number'] === month_3; })[0];
            return year;
        }
    };
    GoodgovernenceService.prototype.changeFormatDate = function (date) {
        if (date === '') {
            return null;
        }
        else {
            var d = new Date(date);
            var month_4 = d.getMonth() + 1;
            var day = d.getDate();
            var year = d.getFullYear() + 543;
            var monthTh = this.checkMonth.filter(function (m) { return m['number'] === month_4; })[0];
            return day + ' ' + monthTh['name'] + ' ' + year;
        }
    };
    GoodgovernenceService.prototype.date_thai = function (date) {
        var d = new Date(date);
        var month = d.getMonth() + 1;
        var day = d.getDate();
        var year = d.getFullYear() + 543;
        var monthTh = this.checkMonth.filter(function (m) { return m['number'] == month; })[0];
        return (day + ' ' + monthTh['name'] + ' ' + year);
    };
    GoodgovernenceService.prototype.date_thai_dd = function (date) {
        var d = new Date(date);
        var month = d.getMonth() + 1;
        var day = d.getDate();
        var year = d.getFullYear() + 543;
        var monthTh = this.checkMonth.filter(function (m) { return m['number'] == month; })[0];
        return (day);
    };
    GoodgovernenceService.prototype.date_thai_mm = function (date) {
        var d = new Date(date);
        var month = d.getMonth() + 1;
        var day = d.getDate();
        var year = d.getFullYear() + 543;
        var monthTh = this.checkMonth.filter(function (m) { return m['number'] == month; })[0];
        return (monthTh['name']);
    };
    GoodgovernenceService.prototype.date_thai_yy = function (date) {
        var d = new Date(date);
        var month = d.getMonth() + 1;
        var day = d.getDate();
        var year = d.getFullYear() + 543;
        var monthTh = this.checkMonth.filter(function (m) { return m['number'] == month; })[0];
        return (year);
    };
    GoodgovernenceService.ngInjectableDef = i0.defineInjectable({ factory: function GoodgovernenceService_Factory() { return new GoodgovernenceService(i0.inject(i1.HttpClient)); }, token: GoodgovernenceService, providedIn: "root" });
    return GoodgovernenceService;
}());
export { GoodgovernenceService };
